module.exports = function isObject(obj){return typeof obj=='object' && obj.constructor == Object;};


/*****************
 ** WEBPACK FOOTER
 ** ./lib/isObject.js
 ** module id = 22
 ** module chunks = 0
 **/